import { render, staticRenderFns } from "./MultiCard.vue?vue&type=template&id=663bf4f8&scoped=true&"
import script from "./MultiCard.vue?vue&type=script&lang=ts&"
export * from "./MultiCard.vue?vue&type=script&lang=ts&"
import style0 from "./MultiCard.vue?vue&type=style&index=0&id=663bf4f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "663bf4f8",
  null
  
)

export default component.exports